import React, { useEffect } from "react"
import OrderProgressiveLoading from "@/components/Shared/OrderHistory/v1/OrderProgressiveLoading"
import PageLoader from "@/components/core/PageLoader/PageLoader"
import { useSelector } from "react-redux"
import { selectGenericState } from "@/store/features/genericSlice"
import AccountsLayout from "@/components/AccountsLayout/AccountsLayout"
import useGenerici18n from "@/i18n/useGeneric"

const MyGenericFiller = ({ data: componentProps, title }) => {
  const staticTexts = useGenerici18n({
    componentProps,
  })
  const { featureFlags = {} } = useSelector(selectGenericState)
  const { ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false } = featureFlags
  useEffect(() => {
    window.scrollTo({
      top: 1,
      behavior: "smooth",
    })
  }, [])
  return (
    <AccountsLayout
      title={
        isSaveProductToList && title === "favoriteTitle"
          ? staticTexts?.listTitle
          : staticTexts?.[title]
      }
      staticTexts={staticTexts}
      i18n={staticTexts}
      accountLayoutLoader={true}
    >
      <PageLoader loading={true} />
      <OrderProgressiveLoading />
    </AccountsLayout>
  )
}

export default MyGenericFiller
